import { updateAttendanceForm } from '@/utils/attendanceFormHelper'

const store = {
  namespaced: true,
  state: () => ({
    id: 'lensometria',
    name: 'Lensometria',
    opened: true,
    showing: true,
    completed: false,
    multiple: false,
    scopes: ['ATTENDANCE', 'PRE_CONSULTATION', 'SURGERY', 'ESSILOR_ATTENDANCE'],
    fields: {
      olhoDireitoEsferico: null,
      olhoDireitoCilindrico: null,
      olhoDireitoEixo: null,
      olhoDireitoAdicao: null,
      olhoEsquerdoEsferico: null,
      olhoEsquerdoCilindrico: null,
      olhoEsquerdoEixo: null,
      olhoEsquerdoAdicao: null,
      usarValoresNaPrescricaoDeOculosLen: null
    }
  }),
  mutations: {
    handleProps: (state, { key, value }) => {
      state[key] = value
    },
    handleFields: (state, { key, value }) => {
      state.fields[key] = value
    },
    checkComplete: state => {
      state.completed = Object.keys(state.fields).some(key => state.fields[key])
    }
  },
  getters: {},
  actions: {
    handleProps(context, { key, value }) {
      context.commit('handleProps', { key, value })

      if (
        context?.rootState?.attendance?.attendance?.id &&
        ['showing', 'opened'].includes(key)
      ) {
        const form = context?.rootGetters['attendance/form/getSelectedForm']
        const forms = form.forms
        const index = forms?.findIndex(form => {
          return form.id === context.state.id
        })

        if (index !== -1) {
          forms[index][key] = value
          form.forms = forms
          updateAttendanceForm(
            context?.rootState?.attendance?.attendance?.attendance_form?.id,
            { forms: forms }
          )
          context.dispatch(`attendance/form/updateAttendanceForms`, form, {
            root: true
          })
        }
      }
    },
    handleFields(context, { key, value }) {
      context.commit('handleFields', { key, value })
      context.commit('checkComplete')
    },
    disableUseGlass({ commit, state, dispatch }) {
      if (state.fields.usarValoresNaPrescricaoDeOculosEst) {
        commit('handleFields', {
          key: 'usarValoresNaPrescricaoDeOculosLen',
          value: false
        })
        dispatch('attendance/form/updateMedicalRecord', state, { root: true })
      }
    },
    useValuesOnGlasses(context, checked) {
      if (checked !== undefined) {
        context.commit('handleFields', {
          key: 'usarValoresNaPrescricaoDeOculosLen',
          value: checked
        })
      }
      const props = {
        suffix: 'Len',
        checked: context.state.fields.usarValoresNaPrescricaoDeOculosLen,
        fields: context.state.fields
      }

      if (context?.rootState?.attendance?.form?.oculos?.opened === false) {
        context.dispatch(
          `attendance/form/oculos/handleProps`,
          { key: 'opened', value: true },
          { root: true }
        )
      }

      if (context?.rootState?.attendance?.form?.oculos?.showing === false) {
        context.dispatch(
          `attendance/form/oculos/handleProps`,
          { key: 'showing', value: true },
          { root: true }
        )
      }

      context.dispatch(
        'attendance/form/oculos/changeFieldsByRefraction',
        props,
        { root: true }
      )
      context.dispatch(
        'attendance/form/refracaoDinamica/disableUseGlass',
        null,
        { root: true }
      )
      context.dispatch(
        'attendance/form/refracaoEstatica/disableUseGlass',
        null,
        { root: true }
      )
    },
    useValuesOnLenses(context, checked) {
      const props = {
        checked,
        suffix: 'Len',
        fields: context.state.fields
      }
      context.dispatch(
        'attendance/form/lentesDeContato/changeFieldsByRefraction',
        props,
        { root: true }
      )
    }
  }
}

export default store
